$(function () {
  $(window).on('scroll', function () {
    if ($(window).scrollTop() === 0) {
      $('#scroll-tip').removeClass('v2-text-transparent');
      $('#scroll-tip').addClass('v2-text-white');
    } else {
      $('#scroll-tip').removeClass('v2-text-white');
      $('#scroll-tip').addClass('v2-text-transparent');
    }
  });
});
